import { useState, useEffect } from "react";
import { KpiCard } from "../../../components/Kpi/KpiCard";
import dummy from "../../../assets/images/Todaysretail.png";
import totalVehicleInvoiced from "../../../assets/images/Total_vehicle_invoiced.svg";
import Active_Insurance from "../../../assets/images/Active_Insurance.svg";
import Insurance_Expires from "../../../assets/images/Insurance_Expires.svg";
import Permit_Issued from "../../../assets/images/Permit_Issued.svg";
import PUC_Fit from "../../../assets/images/PUC_Fit.svg";
import Vehicle_Registration from "../../../assets/images/Vehicle_Registration.svg";
import { axInst, axInstBasic } from "../../../components/Service/Service";
import Loader from "../../../components/Loader/Loader";

export const RtoKpi = ({ isArn }) => {
  // console.log(isArn);
  const [kpiData, setKpiData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!isArn) {
        setError("ARN value is missing.");
        setLoading(false);
        return;
      }

      const basicAuth =
        "Basic " +
        btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

      try {
        const headers = {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        };

        // Fetch data for all KPIs in parallel
        const [
          totalInvoiceRes,
          regLastSixMonthRes,
          activeInsuranceData,
          insuranceExpData,
          permitIssuedData,
          pucFitData,
        ] = await Promise.all([
          axInstBasic.post(
            `${process.env.REACT_APP_API_URL}TotalVehicle`,
            { isArn },
            { headers }
          ),
          axInstBasic.post(
            `${process.env.REACT_APP_API_URL}SixMonthsReg`,
            { isArn },
            { headers }
          ),
          axInstBasic.post(
            `${process.env.REACT_APP_API_URL}TotalActiveInsur`,
            { isArn },
            { headers }
          ),
          axInstBasic.post(
            `${process.env.REACT_APP_API_URL}InsuranceExp`,
            { isArn },
            { headers }
          ),
          axInstBasic.post(
            `${process.env.REACT_APP_API_URL}PermitIssued`,
            { isArn },
            { headers }
          ),
          axInstBasic.post(
            `${process.env.REACT_APP_API_URL}PucFit`,
            { isArn },
            { headers }
          ),
        ]);

        // Combine results into an object
        setKpiData({
          totalInvoicedVehicles: totalInvoiceRes.data.result,
          regLastSixMonths: regLastSixMonthRes.data.result,
          activeInsurance: activeInsuranceData.data.result,
          insuranceExp: insuranceExpData.data.result,
          permitIssued: permitIssuedData.data.result,
          pucFit: pucFitData.data.result,
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isArn]);

  if (loading) {
    return <div>
      <p>Loading... </p>;
      <Loader />
    </div>
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  return (
    <div className="flex flex-col gap-2 max-w-[1200px] w-full">
      <div className="flex md:gap-2 gap-0 md:flex-row flex-col-reverse max-w-[1200px] w-full">
        <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 md:gap-3 gap-2">
          <KpiCard
            Image={totalVehicleInvoiced}
            Alt={"Total Invoiced Vehicles "}
            ColorDark={"bg-gradient-to-b from-[#FFE700] to-[#F9A526]"}
            Title={"Total Invoiced Vehicles "}
            Padding={"p-2"}
            ImageSize={"w-12 h-12"}
            Value={kpiData.totalInvoicedVehicles?.[0]?.doc_count || 0}
          />
          <KpiCard
            Image={Vehicle_Registration}
            Alt={"Reg. In Last 6 Months"}
            ColorDark={"bg-gradient-to-b from-[#3CD0C0] to-[#129BD2]"}
            Title={"Reg. In Last 6 Months"}
            Padding={"p-2"}
            ImageSize={"w-12 h-12"}
            Value={kpiData.regLastSixMonths?.[0]?.doc_count || 0}
          />
          <KpiCard
            Image={Active_Insurance}
            Alt={"Active Insurance"}
            ColorDark={"bg-gradient-to-b from-[#EF6AE9] to-[#8463FA]"}
            Title={"Active Insurance"}
            Padding={"p-2"}
            ImageSize={"w-12 h-12"}
            Value={kpiData.activeInsurance?.[0]?.doc_count || 0}
          />
          <KpiCard
            Image={Permit_Issued}
            Alt={"Permit Issued"}
            ColorDark={"bg-gradient-to-b from-[#FE875D] to-[#FD4D90]"}
            Title={"Permit Issued"}
            Padding={"p-2"}
            ImageSize={"w-12 h-12"}
            Value={kpiData.permitIssued?.[0]?.doc_count || 0}
          />
          <KpiCard
            Image={Insurance_Expires}
            Alt={"Insurance Expires In 3 Months"}
            ColorDark={"bg-gradient-to-b from-[#FFE700] to-[#F9A526]"}
            Title={"Insurance Expires In 3 Months"}
            Padding={"p-2"}
            ImageSize={"w-12 h-12"}
            Value={kpiData.insuranceExp?.[0]?.doc_count || 0}
          />
          <KpiCard
            Image={PUC_Fit}
            Alt={"PUC Fit"}
            ColorDark={"bg-gradient-to-b from-[#00E0FE] to-[#0181D1]"}
            Title={"PUC Fit"}
            Padding={"p-2"}
            ImageSize={"w-12 h-12"}
            Value={kpiData.pucFit?.[0]?.doc_count || 0}
          />
        </section>
      </div>
    </div>
  );
};
